@use '@design/design-tokens/typography/typography' as *;


.dropdownLabelContainer {
  display: flex;
  flex-direction: column;
}

.dropdownLabelSubtitle {
  @include typography-v2-body-xs;

  color: var(--text-soft);
}
